import { isCorrectPhoneObject } from './isCorrectPhoneObject';
import { IPhone } from '../types/newbuilding/phone';

export function phoneToString(phone?: IPhone | null) {
  if (phone && isCorrectPhoneObject(phone)) {
    return `${phone.countryCode}${phone.code}${phone.number}`;
  }

  /* istanbul ignore next */
  return '';
}

export function getPhoneLink(phone?: IPhone | null): string {
  if (phone && isCorrectPhoneObject(phone)) {
    return `${phone.countryCode}${phone.code}${phone.number}`;
  }

  /* istanbul ignore next */
  return '';
}

export function formatNumber(phone?: IPhone | null): string {
  if (phone && isCorrectPhoneObject(phone)) {
    return `${phone.countryCode} (${phone.code}) ${phone.number.replace(/(\d{3})(\d{2})(\d{2})/, '$1-$2-$3')}`;
  }

  /* istanbul ignore next */
  return '';
}
